import { controlerAcces, type Verdict } from '../../../../../web-commun/connexion-google'

export const MESSAGE_REFUS_DISPATCH = "Ce compte n'a pas accès à la console Dispatch. Elle est réservée à l'équipe SwiftEats."

export interface DependancesPersonnel {
  /** `true` = profil admin ou dispatcher ; `false` = autre profil ; `null` = illisible (erreur de lecture). */
  estDuPersonnel: () => Promise<boolean | null>
  deconnecter: () => Promise<void>
}

/**
 * Contrôle d'accès de la console Dispatch, commun à TOUTES les façons d'entrer (mot de passe, code WhatsApp, Google, session
 * restaurée) : cette console est réservée au personnel.
 *
 *  • profil `admin` / `dispatcher` : il entre ;
 *  • autre profil (client, livreur, marchand, compte Google inconnu…) : déconnexion immédiate. Une session Google reçoit toujours
 *    la même phrase, quel que soit le motif ;
 *  • lecture illisible : une session par mot de passe entre (la RLS tient ; un incident de lecture n'enferme pas dehors le
 *    dispatch de garde à deux heures du matin) ; une session GOOGLE est refusée — on n'y laisse pas entrer quelqu'un qu'on n'a pas
 *    pu vérifier.
 */
export async function controlerPersonnel(viaGoogle: boolean, dep: DependancesPersonnel): Promise<Verdict<null>> {
  return controlerAcces({
    viaGoogle,
    deconnecter: dep.deconnecter,
    evaluer: async () => {
      let r: boolean | null
      try {
        r = await dep.estDuPersonnel()
      } catch (e) {
        if (viaGoogle) throw e
        r = null
      }
      if (r === null && viaGoogle) throw new Error('profil illisible')
      return r === false ? { ok: false, message: MESSAGE_REFUS_DISPATCH } : { ok: true, acces: null }
    },
  })
}
